// extracted by mini-css-extract-plugin
module.exports = {"form":"index_form_HyzZ3","border":"index_border_3xaxi","word":"index_word_1cJ5i"};